import {AppState} from '../../configStore';

export const selectUserReportOrderDetails = (state: AppState) => state.userReportOrderDetails;
